import {
    fetchGetAccounts,
    fetchGetStateByStateKey
} from '@iwoca/lapi-client/edge';

export const getAccountsQueryConfig = (stateKey: string) => ({
    queryKey: ['accounts', stateKey],
    queryFn: () => fetchGetAccounts({ stateKey })
});

export const getStateQueryConfig = (stateKey: string) => ({
    queryKey: ['state', stateKey],
    queryFn: () => fetchGetStateByStateKey({ stateKey })
});
